import bdServices from '../../bd-services'

var FormData = require('form-data')

const monitorServices = {}

monitorServices.getAnios = async function () {
  const data = await bdServices.get(`/servidores/tpa/monitor/anios/get_anios.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

monitorServices.insertAnio = async function (form) {
  let formData = new FormData()
  formData.append('anio', form.anio)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/monitor/anios/insert_anios.php'
  }
  const data = await bdServices(options)
  .then(res => res.data )
      .catch((err) => {
        console.error(err)
      })
  return data
}

monitorServices.getBTs = async function () {
  const data = await bdServices.get(`/servidores/tpa/monitor/bts/get_bts.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

monitorServices.insertBts = async function (form) {
  let formData = new FormData()
  formData.append('nombre', form.nombre)
  formData.append('id_anio', form.id_anio)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/monitor/bts/insert_bts.php'
  }
  const data = await bdServices(options)
  .then(res => res.data )
      .catch((err) => {
        console.error(err)
      })
  return data
}

monitorServices.getArchivos = async function () {
  const data = await bdServices.get(`/servidores/tpa/monitor/files/get_files.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

monitorServices.getArchivosEDA = async function () {
  const data = await bdServices.get(`/servidores/tpa/monitor/files/eda/get_fileEDA.php`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

monitorServices.insertFiles = async function (form) {
  let formData = new FormData()
  formData.append('id_bt', form.id_bt)
  formData.append('file', form.file)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/monitor/files/insert_files.php'
  }
  const data = await bdServices(options)
  .then(res => res.data )
      .catch((err) => {
        console.error(err)
      })
  return data
}

monitorServices.deleteFile = async function (form) {
  let formData = new FormData()
  formData.append('id', form.id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/monitor/files/delete_files.php'
  }
  const data = await bdServices(options)
  .then(res => res.data )
      .catch((err) => {
        console.error(err)
      })
  return data
}

monitorServices.insertFileEDA = async function (form) {
  let formData = new FormData()
  formData.append('file', form.file)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/monitor/files/eda/insert_file_eda.php'
  }
  const data = await bdServices(options)
  .then(res => res.data )
      .catch((err) => {
        console.error(err)
      })
  return data
}

monitorServices.deleteFileEDA = async function (form) {
  let formData = new FormData()
  formData.append('id', form.id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/monitor/files/eda/delete_file_eda.php'
  }
  const data = await bdServices(options)
  .then(res => res.data )
      .catch((err) => {
        console.error(err)
      })
  return data
}

monitorServices.changeStatusEDA = async function (newStatus) {
  let formData = new FormData()
  formData.append('ne', newStatus)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/monitor/files/eda/change_publish.php'
  }
  const data = await bdServices(options)
  .then(res => res.data )
      .catch((err) => {
        console.error(err)
      })
  return data
}

monitorServices.changeStatusFile = async function (newStatus, id) {
  console.log("🚀 ~ id:", id)
  console.log("🚀 ~ newStatus:", newStatus)
  let formData = new FormData()
  formData.append('ne', newStatus)
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/monitor/files/change_publish.php'
  }
  const data = await bdServices(options)
  .then(res => res.data )
      .catch((err) => {
        console.error(err)
      })
  return data
}


export default monitorServices



// WEBPACK FOOTER //
// ./src/services/sca/monitor/index.js